import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import {
  initFirebase,
  clearFirebaseLocalStorage,
} from "@shared/services/api/firebase";
import { apiRequest } from "@shared/services/api/apiRequest";
import { getConfig } from "@shared/services/api/config";

type Args = {
  data: any;
  inviteCode: string | null;
  onError?: (error: Error) => void;
};

export async function registerUser({ data, inviteCode, onError }: Args) {
  const { appName } = getConfig();

  // Determine the API endpoint based on the app type
  let apiEndpoint;

  switch (appName) {
    case "portal":
      apiEndpoint = "/api/invite/";
      break;
    case "platform":
      apiEndpoint = "/firebase-signup/";
      break;
  }

  try {
    // Ensure firebase is initialized
    const auth = await initFirebase();

    // Create user
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      data.email,
      data.password
    );

    // Get user
    const user = userCredential.user;

    // Update display name
    await updateProfile(user, {
      displayName: `${data.firstName} ${data.lastName}`,
    });

    // Get ID token
    const idToken = await user.getIdToken();

    // Prepare data for API call
    const body = {
      firebase_token: idToken,
      email: data.email,
      first_name: data.firstName,
      last_name: data.lastName,
      ...(inviteCode ? { invite_code: inviteCode } : {}),
    };

    // Send data to backend
    const response = await apiRequest(apiEndpoint, "POST", body);

    return { authToken: idToken, ...response };
  } catch (error) {
    clearFirebaseLocalStorage();

    onError?.();

    throw error;
  }
}
